import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'

import MinicrudPicker from '../picker/MinicrudPicker'

const MinicrudsFilter = ({ field, label, ...props }) => {
  field = field || 'typeIds'
  label = label || 'Tipos'
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <MinicrudPicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default MinicrudsFilter
